// @flow
import React from 'react';
import classNames from 'classnames';
import type { Option } from './ControlledMultiselect';

type Props = {
  options: Option[],
  id?: string,
  name?: string,
  large?: boolean,
};

const MultiselectFallback = ({
  options,
  large,
  ...rest
}: Props): React$MixedElement => {
  console.error('Multiselect Error Fallback');
  return (
    <select
      className={classNames('select', large && 'select--large')}
      multiple
      {...rest}
    >
      {options.map((option) => (
        <option
          key={option.value}
          value={option.value}
          selected={option.selected}
        >
          {option.text}
        </option>
      ))}
    </select>
  );
};

export default MultiselectFallback;
